import { Client } from '../interfaces/Client';

const saveClient = (client: Client) => {
    localStorage.setItem(client._id, JSON.stringify(client));
};

const getClientFromStorage = (clientId: string) => {
    const str: string = localStorage.getItem(clientId) || '';
    if (!str) return;

    const client: Client = JSON.parse(str);
    return client;
};

export { getClientFromStorage, saveClient };
